<template>
  <div class="table-empty">
    <font-awesome-icon
      class="table-empty__icon"
      :icon="dataIconList" />
    <h4 class="table-empty__text">
      No avaliable data
    </h4>
  </div>
</template>

<script>
import { faList } from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'EmptyTable',
  data () {
    return {
      dataIconList: faList
    };
  }
};
</script>
